// Service metadata — slugs match keys used by backend content_defaults.SERVICE_SLUGS
export const SERVICES = [
  {
    slug: "real-estate",
    icon: "fa-solid fa-building-columns",
    image:
      "https://images.unsplash.com/photo-1604145195376-e2c8195adf29?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
  {
    slug: "afm-registration",
    icon: "fa-solid fa-id-card",
    image:
      "https://images.unsplash.com/photo-1554224155-6726b3ff858f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
  {
    slug: "banking",
    icon: "fa-solid fa-landmark",
    image:
      "https://images.unsplash.com/photo-1601597111158-2fceff292cdc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
  {
    slug: "company-formation",
    icon: "fa-solid fa-briefcase",
    image:
      "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
  {
    slug: "golden-visa",
    icon: "fa-solid fa-passport",
    image:
      "https://images.unsplash.com/photo-1634942062514-6e00d236759d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
  {
    slug: "vehicle-purchases",
    icon: "fa-solid fa-car",
    image:
      "https://images.unsplash.com/photo-1494976388531-d1058494cdd8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
];

export const ASSETS = {
  logo: "/images/logo.png",
  ladyJustice: "/images/lady-justice.jpg",
  library: "/images/library.jpg",
  attorneyStanding: "/images/attorney-standing.jpg",
  attorneySeated: "/images/attorney-seated.jpg",
  athensHero:
    "https://images.unsplash.com/photo-1639150973717-9d584b7cf1fc?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
};
